import { Button } from "antd";
import BkashLogo from "../../../assets/images/bkash-logo.png";
import CustomModal from "../../../components/ui/CustomModal";
import { ModalComponentProps } from "../../../types";

interface BkashDisbursementModalProps extends ModalComponentProps {
  isDisbursementLoading?: boolean;
  handleDisbursement?: () => void;
}

export default function BkashDisbursementModal({
  handleClose,
  handleDisbursement,
  isDisbursementLoading,
  ...rest
}: BkashDisbursementModalProps) {
  return (
    <CustomModal
      title=""
      width={400}
      {...rest}
      handleClose={handleClose}
      footer={null}
    >
      <div className="flex flex-col gap-2">
        <img src={BkashLogo} alt="Bkash" className="w-12" />
        <div className="my-4 text-header text-base font-semibold">
          How to disburse payroll using bKash disbursement solution?
        </div>
        <p className="mb-4 text-display-body text-sm font-normal">
          Disburse your payroll using bKash disbursement solution with 2 simple
          steps.
        </p>
        <p className="mb-4 text-display-body text-sm font-normal">
          <span className="font-semibold">STEP -1.</span> Download the salary
          report in bKash format from here
        </p>
        <p className="mb-4 text-display-body text-sm font-normal">
          <span className="font-semibold">STEP -2.</span> Upload the downloaded
          salary report in your bKash disbursement solution portal.
        </p>
        <div>
          <Button
            type="primary"
            className="mt-2 px-4"
            onClick={handleDisbursement}
            loading={isDisbursementLoading}
          >
            {/* Download  */}
            bKash Disbursement Report
          </Button>
        </div>
      </div>
    </CustomModal>
  );
}
